export class Consideration {
  categoryId: number;
  subCategoryId: number;
  section: string;
  tab: string;
  title: string;
  items: string[];
  brand?: string;
  // Reference Library rows (e.g. cat 75xxx) carry a stable lookup slug here.
  // Pattern reference rows (subCategoryId 4 / 5) store these slugs in items[]
  // and the frontend resolves them via FurtherConsiderations.findByTag().
  tag?: string;

  // Supplement catalog rows (cat 500xxx) carry the LabSmarts report sections a
  // product is for, from the master sheet's own column. Used to group the "add
  // a supplement" picker; absent on rows written before that column existed.
  sections?: string[];

  constructor(consideration?: Consideration) {
    // This handles copying the simple properties
    if (!consideration) {
      return;
    }
    // This handles copying the simple properties
    Object.keys(consideration).forEach(key => {
      this[key] = consideration[key];
    });

    if (consideration.items) {
      this.items = consideration.items.map(item => {
        return item;
      });
    } else {
      this.items = [];
    }
  }
}
